export default "__VITE_ASSET__ov5f7DEf__"